// extracted by mini-css-extract-plugin
export default {"devider":"EditNotificationSensorBoolean_devider__MfzEx"};